import { store } from '../store';
import {
	fetchUser,
	logout,
} from '../slices/user';
import { Auth } from '../../utils/auth';

export default function userLifecycle() {
	if (Auth.getToken())
		store.dispatch(fetchUser());

	window.addEventListener('storage', (e) => {
		if (
			e.key === 'token' ||
			e.key === 'uniqueId'
		) {
			const token = Auth.getToken();
			const uniqueId =
				localStorage.getItem('uniqueId');
			if (token && uniqueId) {
				store.dispatch(fetchUser());
			} else {
				store.dispatch(logout());
			}
		}
	});
}
